import { render } from "./recovery.md?vue&type=template&id=0131bb66"
import script from "./recovery.md?vue&type=script&lang=js"
export * from "./recovery.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__